<template>
    <div class="content">
        <section class="general-page">
            <div class="general-box">
                <div class="inner">
                    <h1>エラーが発生しました</h1>

                    <nuxt-link to="/">
                        <el-button class="btn-general">トップに戻る</el-button>
                    </nuxt-link>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    name: 'Error',
    props: {
        error: {
            type: Object,
            default: null,
        },
    },
    head() {
        return {
            title: 'エラーが発生しました',
        };
    },
};
</script>

<style scoped>
.inner {
    text-align: center;
}
.inner ::v-deep .btn-general {
    margin-bottom: 5rem;
}
</style>
